import React, { useEffect, useState } from "react";
import { Container } from "@mui/material";
import { useJwtStorage, useLocalStorage } from "../../hooks/useLocalStorage";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";

import InputLabel from "@mui/material/InputLabel";
import TextField from "@mui/material/TextField";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

import DrawerAppBar from "../../components/DrawerAppBar";
import Title from "../../components/Title";
import ProgressBar from "../../components/ProgressBar";

import { getSchoolTeachers } from "../../services/SchoolService";
import { saveSuggestion } from "../../services/ActivityService";
import { hasError, getError } from "../../services/ServiceHelper";

const Suggest = () => {
  const [school] = useLocalStorage("Auth", "school", null);
  const [jwt] = useJwtStorage();

  const [showProgress, setShowProgress] = useState(false);

  const [_teachers, setTeachers] = useState([]);
  const [_teacherEid, setTeacherEid] = useState("XX");

  const [name, setName] = useState("");
  const [description, setDescription] = useState("");

  useEffect(() => {
    initTeachers();
  }, []);

  const changeName = (event) => setName(event.target.value);
  const changeDescription = (event) => setDescription(event.target.value);

  const initTeachers = () => {
    setShowProgress(true);

    getSchoolTeachers(school, jwt)
      .then((results) => {
        if (hasError(results) === true) {
          window.showSnack("Unable to get Teachers: " + getError(results));
          return;
        }

        setTeachers(results.data);
      })
      .finally(() => {
        setShowProgress(false);
      });
  };

  const handleAdd = () => {
    if (name === "") {
      window.showAlert("Please enter Activity Name.");
      return;
    }
    if (_teacherEid === "XX") {
      window.showAlert("Please select Teacher.");
      return;
    }

    setShowProgress(true);
    saveSuggestion(school, jwt, name, description, _teacherEid)
      .then((results) => {
        if (hasError(results) === true) {
          window.showSnack(
            "Unable to save Suggestion: " + getError(results)
          );
          return;
        }
        window.showAlert("Suggestion Submitted!");
      })
      .finally(() => {
        setShowProgress(false);
      });
  };

  const handleChangeTeacher = (event) => {
    const eid = event.target.value;

    setTeacherEid(eid);

    if (eid === "XX") {
      window.showAlert(null, "Please Select a Teacher.");
      return;
    }
  };
  return (
    <>
      <DrawerAppBar />

      <Container sx={{ mt: 1 }}>
        <Title text="Suggest an Activity" showBack={true} />
        <ProgressBar showProgress={showProgress} />

        <Alert severity="info" key={alert.title}>
          <AlertTitle>Instructions</AlertTitle>
          You can suggest an activity to your teacher. Please enter the values
          below and click Add Suggestion.
        </Alert>

        <Box sx={{ boxShadow: 1, p: 1, mt: 1 }}>
          <InputLabel>* New Activity Name</InputLabel>
          <TextField
            autoFocus
            margin="dense"
            id="name"
            type="text"
            fullWidth
            variant="outlined"
            onChange={changeName}
          />

          <InputLabel>Description (optional)</InputLabel>
          <TextField
            margin="dense"
            id="description"
            type="text"
            fullWidth
            variant="outlined"
            onChange={changeDescription}
          />

          <InputLabel>* Teacher</InputLabel>
          <Select
            id="teacherEid"
            onChange={handleChangeTeacher}
            value={_teacherEid}
            fullWidth
          >
            <MenuItem value="XX">-- SELECT TEACHER --</MenuItem>
            {_teachers.map((teacher) => (
              <MenuItem key={teacher.eid} value={teacher.eid}>
                {teacher.last_name}, {teacher.first_name}
              </MenuItem>
            ))}
          </Select>

          <br />

          <Button onClick={handleAdd} sx={{ mt: 2 }} variant="contained">
            Add Suggestion
          </Button>
        </Box>
      </Container>
    </>
  );
};

export default Suggest;
